<div>
  @if (item.serialNumber && !isSignatureIdentity(item)) {
    <div class="row">
      <div class="col pb-0">
        <span>
          {{ ('customer_mngt.identityData' + item.type) | translate }}@if (checkIdentityRequired(item.type)) {
            <span class="requireSym">*</span>
          }
          <span style="margin-left: -3px"> : </span>
        </span>
        <span class="font-bold">{{ item.serialNumber }}</span>
      </div>
    </div>
  }

  @if (item.issuingAuthority) {
    <div class="row">
      <div class="col pb-0">
        <span class="" translate>customer_mngt.issued</span>:
        <span class="font-weight-600">{{ item.issuingAuthority }}</span>
      </div>
    </div>
  }

  @if (item.expire) {
    <div class="row">
      <div class="col pb-0">
        <span class="" translate>customer_mngt.valid</span>:
        <span class="font-weight-600">{{ item.expire }}</span>
      </div>
    </div>
  }

  @if (item.description) {
    <div class="row">
      <div class="col pb-0">
        <span class="" translate>common.description</span>:
        <span class="font-weight-600">{{ item.description }}</span>
      </div>
    </div>
  }

  <!-- Image Section -->
  @if (item.type === 'ID_CARD' && item?.imageSrcImage?.['ID_CARD']) {
    <div class="row mb-4">
      <div class="col-6">
        <span translate>customer_mngt.id-img</span>:
        <img src="assets/img/imageIcon.png" alt="" width="20"
          pTooltip="ID Card image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
          (click)="showImage('ID Card image', item.imageSrcImage['ID_CARD'])">
        </div>
      </div>
    }

    @if (item.type === 'NATIONAL_PASSPORT' && item?.imageSrcImage?.['PASSPORT']) {
      <div class="row mb-4">
        <div class="col-6">
          <span translate>customer_mngt.pass-img</span>:
          <img src="assets/img/imageIcon.png" alt="" width="20"
            pTooltip="Passport image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
            (click)="showImage('Passport image', item.imageSrcImage['PASSPORT'])">
          </div>
        </div>
      }

      @if (item.type === 'FOREIGN_PASSPORT' && item?.imageSrcImage?.['PASSPORT']) {
        <div class="row mb-4">
          <div class="col-6">
            <span translate>customer_mngt.for-pass-img</span>:
            <img src="assets/img/imageIcon.png" alt="" width="20"
              pTooltip="Foreign Passport image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
              (click)="showImage('Foreign Passport image', item.imageSrcImage['PASSPORT'])">
            </div>
          </div>
        }

        @if (item.type === 'SSC' && item?.imageSrcImage?.['SSC']) {
          <div class="row mb-4">
            <div class="col-6">
              <span translate>customer_mngt.ssc</span>:
              <img src="assets/img/imageIcon.png" alt="Social Security Card image" width="20"
                pTooltip="Social Security Card image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Social Security Card image', item.imageSrcImage['SSC'])">
            </div>
          </div>
        }

        @if (item.type === 'OTHER' && item?.imageSrcImage?.['OTHER']) {
          <div class="row mb-4">
            <div class="col-6">
              <span translate>customer_mngt.other_img</span>:
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="Other image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Other', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'STATE_REGISTER_CERTIFICATE' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.state_register_certificate_img</span>: -->
              <span>State Register Certificate image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="State Register Certificate image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('State Register Certificate', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'COMPANY_TAX_CODE' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.company_tax_code_img</span>: -->
              <span>Company Tax Code image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="Company Tax Code image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Company Tax Code', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'COMPANY_LICENSE' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.company_license_img</span>: -->
              <span>Company License image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="Company License image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Company License', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'COMPANY_REGISTRY_NUMBER' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.company_registry_number_img</span>: -->
              <span>Company Registry Number image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="Company Registry Number image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Company Registry Number', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'SHAREHOLDER_REGISTRY' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.shareholder_registry_img</span>: -->
              <span>Shareholder Registry image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="Shareholder Registry image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Shareholder Registry', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'UBO_DECLARATION' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.ubo_declaration_img</span>: -->
              <span>UBO Declaration image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="UBO Declaration image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('UBO Declaration', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'DIRECTOR_APPOINTMENT_RESOLUTION' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.director_appointment_resolution_img</span>: -->
              <span>Director Appointment Resolution image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="Director Appointment Resolution image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Director Appointment Resolution', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'LEGAL_ENTITY_IDENTIFIER' && item?.identityDocuments?.length > 0) {
          <div class="row mb-4">
            <div class="col-6">
              <!-- <span translate>customer_mngt.legal_entity_identifier_img</span>: -->
              <span>Legal Entity Identifier image:</span>
              <img src="assets/img/imageIcon.png" alt="" width="20"
                pTooltip="Legal Entity Identifier image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Legal Entity Identifier', item.imageSrcImage?.['OTHER'])">
            </div>
          </div>
        }

        @if (item.type === 'SIGNATURE' && item?.imageSrcImage?.['SIGNATURE']) {
          <div class="row mb-4 signature-row">
            <div class="col-6">
              <span translate>customer_mngt.signature-img</span>:
              <img src="assets/img/imageIcon.png" alt="Signature image" width="20"
                pTooltip="Signature image" tooltipPosition="bottom" class="cursor-pointer" tooltipStyleClass="tooltip-class"
                (click)="showImage('Signature', item.imageSrcImage['SIGNATURE'])">
            </div>
          </div>
        }
            </div>

            <p-dialog [header]="titleDialog" [(visible)]="isShowDialog" [style]="{maxWidth: '60vw'}"
              [modal]="true" [dismissableMask]="true">
              <div>
                @if (srcImageDialog) {
                  <img
                    [src]="srcImageDialog"
                    alt="full size">
                }
              </div>
            </p-dialog>
